/**
 * Generic helper to format API data arrays into select options.
 * @param {Array} data - The array of objects from API.
 * @param {string} labelKey - The key to use for the label.
 * @param {string} valueKey - The key to use for the value (default: 'id').
 * @param {Function} filterFn - Optional filter function.
 * @returns {Array} - Formatted options [{ value, label }].
 */
export const formatToOptions = (data, labelKey, valueKey = "id", filterFn = null) => {
  if (!Array.isArray(data)) return [];
  const items = filterFn ? data.filter(filterFn) : data;
  return items.map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
  }));
};
